import React, {useEffect} from 'react';
import ReactDOM from "react-dom/client";
import {Provider, useDispatch, useSelector} from 'react-redux';
import {Route, Routes, useNavigate, useLocation} from 'react-router-dom';
import {HistoryRouter} from "redux-first-history/rr6";
import {PersistGate} from 'redux-persist/integration/react';
import {Loader} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

import {persistor, routerHistory, store} from './configureStore';
import App from './App';

import Home from './views/Home';
import Search from './views/Search';
import CheckoutStepShipping from './views/Checkout_1_StepShipping';
import CheckoutStepPayment from './views/Checkout_2_StepPayment';
import FAQ from './views/FAQ';
import ArchiveEvents from './views/ArchiveEvents';
import TravelPlan from './views/TravelPlan';
import BusinessProgram from "./views/BusinessProgram";
import EventsAE from "./views/EventsAE";
import Bookmarks from "./views/Bookmarks";
import Profile from './views/Profile';
import EditProfile from "./views/EditProfile";
import Scan from "./views/Scan";
import Support from "./views/Support";
import Company from "./views/Company";
import Ticket from "./views/Ticket";
import Exponent from "./views/Exponent";
import AsiaMeet from "./views/AsiaMeet";
import Notifications from "./views/Notifications";
import Exponents from "./views/Exponents";
import PdfFile from "./views/PdfFile";
import PushInstruction from "./views/PushInstruction";

import './index.css';
import CheckoutStepConfirm from "./views/Checkout_3_StepConfirm";
import Orders from "./views/Orders";
import Order from "./views/Order";
import {closeMenu} from "./components/NavBottomBar/actions";
import {closeSearch} from "./components/NavTopBar/actions";
import {isSearchVisible} from "./components/NavTopBar/reducer";
import {getAuthToken, getUserData, getUserLoggedIn} from "./components/UserLogin/reducer";
import {getLocationData} from "./components/GeoLocation/reducer";
import {isMenuVisible} from "./components/NavBottomBar/reducer";
import {isArray} from "lodash";
import EventBP from "./views/BusinessProgram_event";
import Persons from "./views/Persons/";

import FilteredExponents from "./views/Exponents/FilteredExponents";
import PdfPresentation from "./views/PdfFile/PdfPresentation";
import CanvasComponent from "./components/Canvas/canvas";
import EnLocalization from "./views/Home/EnLocalization";
import NotifyPage from "./views/Notification_page";
import Exposition from "./views/Exposition";
import DescriptionCongressGras from './views/GrasExpo/DescriptionCongress';
import HomeGras from "./views/GrasExpo/Home";
import BusinessProgramGras from "./views/GrasExpo/BusinessProgram";
import EventBPGras from "./views/GrasExpo/BusinessProgram_event";
import DescriptionCongress from "./views/DescriptionCongress"
import CulturalProgram from "./views/CulturalProgram"
import ExponentCard from "./views/ExponentCard";
import ExpositionGras from "./views/GrasExpo/Exposition";
import ExponentsGras from "./views/GrasExpo/Exponents";

import mixpanel from 'mixpanel-browser';
import {MIXPANEL_API_KEY} from "./config/secrets";
import Exposition25Y from "./views/CongressAE2025/Exposition";
import CreateMeeting from "./views/AsiaMeet/CreateMeeting";
const MIXPANEL_TOKEN = MIXPANEL_API_KEY;
const MIXPANEL_CONFIG = {
    debug: true,
    track_pageview: true,
    persistence: 'localStorage'
};
mixpanel.init(MIXPANEL_TOKEN, MIXPANEL_CONFIG);

const root = ReactDOM.createRoot(document.getElementById("root"));

console.log(`App "${process.env.REACT_APP_NAME}" version ${process.env.REACT_APP_VERSION} API Backend ${process.env.REACT_APP_API_URL} is running in ${process.env.REACT_APP_ENV} mode`)

const withRouter = (Component) => (props) => {

    const router = useSelector((state) => state.router);

    //console.log(useLocation());

    const defaultProps = {
        navigate: useNavigate(),
        dispatch: useDispatch(),
        searchVisible: useSelector((state) => isSearchVisible(state.navtopbar)),
        menuVisible: useSelector((state) => isMenuVisible(state.navbottombar)),
        userData: useSelector((state) => getUserData(state.userLogin)),
        userLocation: useSelector((state) => getLocationData(state.userLocation)),
        isLoggedIn: useSelector((state) => getUserLoggedIn(state.userLogin)),
        token: useSelector((state) => getAuthToken(state.userLogin)),
        mixpanel,
        routeAction: router.action,
        location: router.location,
        previousLocations: router.previousLocations,
        isPageReloaded: router.action === 'POP' && isArray(router.previousLocations) && _.size(router.previousLocations) === 1,
    }
    const {menuVisible, searchVisible, dispatch} = defaultProps;

    useEffect(() => {
        if (menuVisible)
            dispatch(closeMenu());

        if (searchVisible)
            dispatch(closeSearch());
    }, []);

    return <Component {...defaultProps}/>;
}

root.render(
  <Provider store={store}>
    <PersistGate loading={<Loader active />} persistor={persistor}>
      <HistoryRouter history={routerHistory}>
        <App>
          <Routes>
              <Route exact path={`/`} Component={withRouter(Home)} />
              <Route path={`/search/:search`} Component={withRouter(Search)} />
              <Route path={`/en`} Component={withRouter(EnLocalization)} />
              <Route path={`/faq`} Component={withRouter(FAQ)} />
              <Route path={`/description-congress`} Component={withRouter(DescriptionCongress)} />
              {/*<Route path={'/cultural-program'} Component={withRouter(CulturalProgram)}/>*/}
              <Route path={'/archive-events'} Component={withRouter(ArchiveEvents)}/>
              <Route path={'/events-asiaexpo'} Component={withRouter(EventsAE)}/>
              <Route path={'/bookmarks'} Component={withRouter(Bookmarks)}/>
              <Route path={'/travel-plan'} Component={withRouter(TravelPlan)}/>
              <Route path={'/profile'} Component={withRouter(Profile)} />
              <Route path={'/profile/edit'} Component={withRouter(EditProfile)} />
              <Route path={'/scan'} Component={withRouter(Scan)} />
              <Route path={'/support'} Component={withRouter(Support)} />
              <Route path={'/profile/company'} Component={withRouter(Company)} />
              <Route path={'/ticket'} Component={withRouter(Ticket)} />
              <Route path={'/schedule'} Component={withRouter(BusinessProgram)} />
              <Route path={'/profile/exponents'} Component={withRouter(Exponent)} />
              <Route path={'/asiameet'} Component={withRouter(AsiaMeet)} />
              <Route path={'/notifications'} Component={withRouter(Notifications)} />
              <Route path={'/business-program'} Component={withRouter(BusinessProgram)} />
              <Route path={'/business-program/event/:forumId'} Component={withRouter(EventBP)} />
              <Route path={'/policy'} Component={withRouter(PdfFile)} />
              <Route path={'/exponent-presentation'} Component={withRouter(PdfPresentation)} />
              <Route path={'/checkout-step-shipping'} Component={withRouter(CheckoutStepShipping)} />
              <Route path={'/checkout-step-payment'} Component={withRouter(CheckoutStepPayment)} />
              <Route path={'/checkout-step-confirm/:orderKey'} Component={withRouter(CheckoutStepConfirm)} />
              <Route path={'/exponents/:segmentId'} Component={withRouter(FilteredExponents)} />
              <Route path={'/exposition'} Component={withRouter(Exposition25Y)} />
              <Route path={'/exposition/:exponentId'} Component={withRouter(Exposition)} />
              <Route path={'/notifications/:notifId'} Component={withRouter(NotifyPage)} />
              <Route path={'/persons'} Component={withRouter(Persons)} />
              <Route path={'/gras'} Component={withRouter(HomeGras)} />
              <Route path={'/gras/description-congress'} Component={withRouter(DescriptionCongressGras)} />
              <Route path={'/gras/business-program'} Component={withRouter(BusinessProgramGras)} />
              <Route path={'/gras/business-program/:forumId'} Component={withRouter(EventBPGras)} />
              <Route path={'/exponents'} Component={withRouter(Exponents)} />
              <Route path={'/gras/exposition'} Component={withRouter(ExpositionGras)} />
              <Route path={'/gras/exponents'} Component={withRouter(ExponentsGras)} />
              <Route path={'/exponents/exponents-card/:exponentId'} Component={withRouter(ExponentCard)} />
              <Route path={'/create-meeting'} Component={withRouter(CreateMeeting)} />
              <Route path={'/instruction'} Component={withRouter(PushInstruction)} />
          </Routes>
        </App>
      </HistoryRouter>
    </PersistGate>
  </Provider>
);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('webPushServiceWorker.js')
            .then((registration) => {
                console.log('WebPush Service Worker зарегистрирован:', registration);
            })
            .catch((error) => {
                console.log('Ошибка регистрации WebPush Service Worker:', error);
            });
    });
}

export default withRouter;

